import { render, staticRenderFns } from "./activateDialog.vue?vue&type=template&id=570a3354&scoped=true"
import script from "./activateDialog.vue?vue&type=script&lang=js"
export * from "./activateDialog.vue?vue&type=script&lang=js"
import style0 from "./activateDialog.vue?vue&type=style&index=0&id=570a3354&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a3354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570a3354')) {
      api.createRecord('570a3354', component.options)
    } else {
      api.reload('570a3354', component.options)
    }
    module.hot.accept("./activateDialog.vue?vue&type=template&id=570a3354&scoped=true", function () {
      api.rerender('570a3354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/call/component/activateDialog.vue"
export default component.exports